import { keyframes as k } from '../../_snowpack/pkg/styled-components.js';
const revealScaleOpacity = k(["from{opacity:0;transform:scale(.75)}to{opacity:1;transform:none;}"]);
export const keyframes = {
  revealScaleOpacity
};